import React from 'react';
import BASIC from '../BASIC';
import PREMIUM from '../PREMIUM';
import STANDARD from '../STANDARD';



const Pricing = ({ color, serviceDetails }) => {
    const [openTab, setOpenTab] = React.useState(1);


    return (
        <div className="md:flex md:flex-wrap mx-5 shadow-slate-600 shadow-lg sticky top-24">
            <div className="w-full px-5">
                <ul
                    className="md:flex mb-0 list-none md:flex-wrap pt-3 pb-4 flex-row "
                    role="tablist"
                >
                    <li className="-mb-px my-2 mr-2 last:mr-0 md:flex-auto text-center">
                        <a
                            className={
                                "text-lg hover:text-[#ff014f] tracking-widest font-semibold  shadow-slate-600 rounded-lg  uppercase p-2 shadow-lg block leading-normal " +
                                (openTab === 1
                                    ? "text-[#ff014f] bg-" + color + "-600"
                                    : "text-[#C4CFDE]" + color + "-600 bg-[#202327]")
                            }
                            onClick={e => {
                                e.preventDefault();
                                setOpenTab(1);
                            }}
                            data-toggle="tab"
                            href="#link1"
                            role="tablist"
                        >
                            BASIC
                        </a>
                    </li>
                    <li className="-mb-px my-2 mr-2 last:mr-0 flex-auto text-center">
                        <a
                            className={
                                "text-lg hover:text-[#ff014f] tracking-widest font-semibold  shadow-slate-600 rounded-lg shadow-lg uppercase p-2 block leading-normal " +
                                (openTab === 2
                                    ? "text-[#ff014f] bg-" + color + "-600"
                                    : "text-[#C4CFDE]" + color + "-600 bg-[#202327]")
                            }
                            onClick={e => {
                                e.preventDefault();
                                setOpenTab(2);
                            }}
                            data-toggle="tab"
                            href="#link2"
                            role="tablist"
                        >
                            STANDARD
                        </a>
                    </li>
                    <li className="-mb-px my-2 mr-2  flex-auto text-center">
                        <a
                            className={
                                "text-lg hover:text-[#ff014f] tracking-widest font-semibold  shadow-slate-600 rounded-lg shadow-lg uppercase p-2 block leading-normal " +
                                (openTab === 3
                                    ? "text-[#ff014f] bg-" + color + "-600"
                                    : "text-[#C4CFDE]" + color + "-600 bg-[#202327]")
                            }
                            onClick={e => {
                                e.preventDefault();
                                setOpenTab(3);
                            }}
                            data-toggle="tab"
                            href="#link3"
                            role="tablist"
                        >
                            PREMIUM
                        </a>
                    </li>
                </ul>

                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded">
                    <div className="px-4 py-5 flex-auto">
                        <div className="tab-content tab-space">
                            <div className={openTab === 1 ? "block" : "hidden"} id="link1">
                                <BASIC serviceDetails={serviceDetails} />
                            </div>
                            <div className={openTab === 2 ? "block" : "hidden"} id="link2">
                                <STANDARD serviceDetails={serviceDetails} />
                            </div>
                            <div className={openTab === 3 ? "block" : "hidden"} id="link3">
                                <PREMIUM serviceDetails={serviceDetails} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pricing;